/**
 * @flow
 * @file Preview sidebar more tabs loading component
 * @author Box
 */

import * as React from 'react';
import { bdlGray10 } from '../../../styles/variables';
import IconEllipsis from '../../../icons/general/IconEllipsis';

const MoreTabPlaceholder = () => {
    return (
        <div className="bdl-AdditionalTabPlaceholder">
            <IconEllipsis color={bdlGray10} className="bdl-AdditionalTabPlaceholder-moreIcon" />
        </div>
    );
};

export default MoreTabPlaceholder;
